import { Typeahead } from "react-bootstrap-typeahead";
import "./Typeahead.css";

//https://www.npmjs.com/package/react-bootstrap-typeahead
//https://github.com/ericgio/react-bootstrap-typeahead

export default function AutocompleteSingle(props) {
  return <Typeahead size="sm" placeholder={props.placeholder}  id={"id" + props.reactKey}  key={props.reactKey}
    clearButton labelKey={props.labelKey} onChange={props.onChange} options={props.options}
    style={props.style} selected={props.selected} inputProps={props.inputProps} onBlur={props.onBlur}
    />;
}

